export default function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-hierarchy/src/hierarchy/eachAfter.js
// module id = hBXQ
// module chunks = 0